import Refresh from "@mui/icons-material/Refresh";
import { Handle, type NodeProps, Position } from "@xyflow/react";

import type { ForEachSentinelRuleNode } from "./loopTypes";
import LoopSentinelCard from "./LoopSentinelCard";

type ForEachSentinelNodeProps = NodeProps<ForEachSentinelRuleNode>;

const ForEachSentinelNode = ({ data, selected }: ForEachSentinelNodeProps) => {
	const description = data.tableName ? `Table: ${data.tableName}` : "Start of the loop";

	return (
		<LoopSentinelCard
			icon={<Refresh fontSize="small" />}
			accentColor="#06B097"
			gradId="coapp-grad-primary"
			label="Loop Start"
			title="Start"
			badge="Entry point"
			description={description}
			selected={selected}
		>
			<Handle type="target" position={Position.Left} id="in" isConnectable />
			<Handle type="source" position={Position.Bottom} id="loop-start" isConnectable />
			{data.iterateType !== "variable" ? (
				<Handle type="source" position={Position.Right} id="afterLast-out" isConnectable />
			) : null}
		</LoopSentinelCard>
	);
};

export default ForEachSentinelNode;
